module.exports = __webpack_public_path__ + "img/Kat.d590d1ef.jpg";